export class Fee {
    amount: number;
    description: string;
    note?: string;
}
